<template>
    <div class="tixianjilu">
        <div class="tit">提现记录</div>
        <el-form inline>
            <el-form-item>
                <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索</el-button>
                <el-button type="primary">刷新</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData">
            <el-table-column label="申请提现订单单号"></el-table-column>
            <el-table-column prop="addtime" label="申请时间"></el-table-column>
            <el-table-column prop="money" label="提现金额"></el-table-column>
            <el-table-column prop="transferStatus" label="提现状态"></el-table-column>
            <el-table-column label="财务上传提现截图软件"></el-table-column>
            <el-table-column label="操作">
                <template scoped="scoped"> 查看 </template>
            </el-table-column>
        </el-table>


		<el-pagination background
                       layout="prev, pager, next"
                       @current-change="pagingChange"
                       :total="paging.total">
        </el-pagination>


    </div>
</template>

<script>
import { settlelList } from "@/api/chongzhi";
export default {
    data() {
        return {
            form: {
                time: "",
            },

			paging: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            tableData: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            settlelList({
				...this.paging
			}).then((res) => {
                let { total, rows } = res;
                console.log("提现记录", res);
				this.tableData = rows
				this.paging.total = total
            });
        },
		pagingChange (e) {
            console.log('e', e);
            this.paging.pageNum = e
            this.getList()
        },
    },
};
</script>

<style lang="scss" scoped>
</style>